import { defineStore } from "pinia";
import { cloneDeep } from "lodash";
import type { Task } from "../types";

interface TaskFilter {
  status: string | null;
  priority: string | null;
  search: string;
}

export const useTaskStore = defineStore("tasks", {
  state: () => ({
    tasks: [] as Task[],
    selectedTask: null as Task | null,
    filter: { status: null, priority: null, search: "" } as TaskFilter,
    isLoading: false,
  }),

  actions: {
    setTasks(tasks: Task[]) {
      this.tasks = cloneDeep(tasks);
      this.isLoading = false;
    },

    addTask(task: Task) {
      this.tasks.push(task);
    },

    updateTask(id: string, updates: Partial<Task>) {
      const index = this.tasks.findIndex((t) => t.id === id);
      if (index !== -1) {
        this.tasks[index] = { ...this.tasks[index], ...updates };
      }
    },

    deleteTask(id: string) {
      this.tasks = this.tasks.filter((t) => t.id !== id);
      if (this.selectedTask?.id === id) {
        this.selectedTask = null;
      }
    },

    selectTask(task: Task | null) {
      this.selectedTask = task ? cloneDeep(task) : null;
    },

    setFilter(filter: Partial<TaskFilter>) {
      this.filter = { ...this.filter, ...filter };
    },
  },

  getters: {
    filteredTasks(state): Task[] {
      return state.tasks.filter((t) => {
        if (state.filter.status && t.status !== state.filter.status) return false;
        if (state.filter.priority && t.priority !== state.filter.priority) return false;
        if (state.filter.search && !t.title.toLowerCase().includes(state.filter.search.toLowerCase())) return false;
        return true;
      });
    },
  },
});
